import { type DiscreteValueOption, type MultiValueOption } from "../api";
import { type ResolvedDiscreteValueOption } from "./ResolvedDiscreteValue";
import { type ResolvedMultiValueOption } from "./ResolvedMultiValueValue";

export const resolveOptionsValue = (
    options: DiscreteValueOption | MultiValueOption
): ResolvedDiscreteValueOption | ResolvedMultiValueOption | never => {
    if (!options.value) {
        throw new Error("DiscreteOption: Property 'value' must be provided.");
    }

    if (!options.label) {
        throw new Error("DiscreteOption: Property 'label' must be provided.");
    }

    return {
        value: options.value,
        label: options.label,
        tooltip: options.tooltip,
        calculationValue: options.calculationValue,
    };
};
